import { FlowEditor } from './components';

function App() {
  return (
    <div className="w-screen h-screen">
      <FlowEditor />
    </div>
  );
}

export default App;
